module.exports = __webpack_public_path__ + "img/57.71bb781e.png";